import { render, staticRenderFns } from "./createcity.vue?vue&type=template&id=4d8d61d6&"
import script from "./createcity.vue?vue&type=script&lang=ts&"
export * from "./createcity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createcity.vue"
export default component.exports